import { useEffect, useState } from 'react';
import { getDatabase, onChildAdded, onChildChanged, ref } from 'firebase/database';
import { FirebaseApp } from 'firebase/app';

const useFirebaseRealtimeDatabaseChildren = <T>(key: string, app?: FirebaseApp): T | undefined => {
  const [value, setValue] = useState<T | undefined>(undefined);

  useEffect(() => {
    const db = getDatabase(app);
    const valueRef = ref(db, key);

    const addedUnsubscribe = onChildAdded(valueRef, (snapshot) => {
      const data = snapshot.val() as { data: T };
      setValue(data.data);
    });
    const changedUnsubscribe = onChildChanged(valueRef, (snapshot) => {
      const data = snapshot.val() as { data: T };
      setValue(data.data);
    });

    return () => {
      addedUnsubscribe();
      changedUnsubscribe();
    };
  }, [app, key]);

  return value;
};

export default useFirebaseRealtimeDatabaseChildren;
